module.exports = __webpack_public_path__ + "static/media/glasses.595e3644.svg";